import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { HomeScreens } from "./HomeScreens";
import logOutUser from "../screens/Logout";

export type LogoutStackParamList = {
  [HomeScreens.LOGOUT]: undefined;
};

const Stack = createStackNavigator<LogoutStackParamList>();

export const LogoutNavigation = () => {
  return (
    <Stack.Navigator
      screenOptions={({ route, navigation }) => ({
          headerShown:  false,  // no header bar
          gestureEnabled: false // no back gestures
      })}
    >
      <Stack.Screen
        name={HomeScreens.LOGOUT}
        key="logout"
        component={logOutUser}
      />
    </Stack.Navigator>
  );
};
